import styled from '@emotion/styled'

const DISTANCE_FROM_TARGET = 16

export const MODAL_HEIGHT = 260

export const Container = styled.div`
  border: 1px solid #7f52ff;
  border-radius: 10px;
  margin-top: ${DISTANCE_FROM_TARGET}px;
  max-height: ${MODAL_HEIGHT}px;
  background-color: #f6f8fa;
  font-family: 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: auto;
  letter-spacing: 0.15px;
  box-shadow: 0px 4px 20px 0px #6c9f882e;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 14px;
  }

  ::-webkit-scrollbar-track {
    background-color: #eee;
    border-radius: 14px;
  }
`

export const getBaseModalCss = (shouldModalOpenUp: boolean) => `
  position: fixed;
  width: 242px;
  z-index: 9999;

  &::before {
    content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEwxNy42NjAzIDE1TDAuMzM5NzQ2IDE1TDkgMFoiIGZpbGw9IiM3RjUyRkYiLz4KPC9zdmc+Cg==");
    ${
      shouldModalOpenUp
        ? `bottom: -14px;
       transform: rotate(180deg);
      `
        : `
       top: 2px;
      `
    }
    
    left: 50%;
    position: absolute;
  }
`

export const fadeInAnimationVariants = {
  initial: {
    opacity: 0,
    scale: 0.75,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.15,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.75,
    transition: {
      ease: 'easeIn',
      duration: 0.15,
    },
  },
}
